// extracted by mini-css-extract-plugin
module.exports = {"HERO":"Hero_HERO__nvfuF","HERO__btn_icon":"Hero_HERO__btn_icon__1Eq9d"};